import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';
import UserStore from './UserStore';
import AjaxPromises from '../utils/AjaxPromises';
import * as _ from 'lodash';
import { endPoints as PermissionEndpoints, events as PermissionEvents } from '../constants/PermissionConstants';
import { actions as AuthActions } from '../constants/AuthConstants';
import { actions as UserActions } from '../constants/UserConstants';

class PermissionStore extends EventEmitter {
    constructor() {
        super();
        this.refresh = this.refresh.bind(this);
        this.actionHandler = this.actionHandler.bind(this);
        AppDispatcher.register(this.actionHandler);
    }

    get permissions() {
        return _.values(this._permissions);
    }

    userCan(permission) {
        return !!this._permissions[permission];
    }

    async refresh() {
        try {
            let data = UserStore.getApiData();
            let resp = await AjaxPromises.POST(PermissionEndpoints.GET_PERMISSIONS, data);

            if(!resp.Result) {
                throw resp;
            }
            this._permissions = _.keyBy(resp.Data, x => x);
            this.emitChange();
        }
        catch(ex) {
            console.warn(`Failed to load permissions.`, ex);
        }
    }

    emitChange() {
        this.emit(PermissionEvents.CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(PermissionEvents.CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(PermissionEvents.CHANGE_EVENT, callback);
    }

    actionHandler(action) {
        switch(action.actionType) {
            case AuthActions.LOGIN:
                this.refresh();
                break;
            case UserActions.SELECT_LOCATION:
                this.refresh();
                break;
        }
    }
}

let permissions = new PermissionStore();
export default permissions;



// WEBPACK FOOTER //
// ./ui_src/app/stores/PermissionStore.jsx